import React from "react";
import PropTypes from "prop-types";

import styles from "./Button.module.css";

const UIButtonSecondary = ({ className, children, ...nativeProps }) => {
  return (
    <button {...nativeProps} className={`${styles.secondary} ${className}`}>
      {children}
    </button>
  );
};

UIButtonSecondary.propTypes = {
  className: PropTypes.string
};

export default UIButtonSecondary;
